// extracted by mini-css-extract-plugin
export default {"input":"FormatDetail_input__BybLd"};